export default {
  deleteTitle: 'University',
  overviewTitle: 'Universities',
  overviewRouterUrl: 'universities',
  getFilterName (context) { return 'universities' },
  overviewApiUrl: '/universities/',
  detailTitle: 'University Detail',
  detailRouterUrl: 'university',
  detailApiUrl: '/universities/',
  quickFilterName: 'Name',
  quickFilterField: 'name',
  sortOrder: [
    {
      field: 'name',
      sortField: 'name',
      direction: 'asc'
    }
  ],
  fields:
  [
    {title: 'Name', name: 'name', sortField: 'name', link: '#/university/{id}'},
    {title: 'Short Name', name: 'shortname', sortField: 'shortname'},
    {name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center'}
  ]
}



// WEBPACK FOOTER //
// ./src/views/University/FieldDefs.js